import React from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

// Portal to document.body so the modal lives in the root stacking context
// (Bootstrap gives it z-index 1050) rather than inside a webtop-window
// (z-index 10). Without this, Bootstrap's .modal-backdrop (z-index 1040,
// appended to <body> by Bootstrap JS) sits above the window stacking context
// and intercepts all clicks/focus on the form, making inputs non-editable.
const Modal = ({ id, title,label,isOpen,style,size,layout, children, handleModalClose, handleSubmit, isUserDataValid,disabled }) => {
  const disable=useSelector((state)=>state.employee.button)
  const modal = (
    <div id={id} className={`modal custom-modal fade ${isOpen}`} role="dialog" style={style}  data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
      <div className={`modal-dialog modal-dialog-centered ${size === "md" ? "modal-md" : "modal-lg"}`} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={handleModalClose} data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit} layout={layout}>
              {children}
              <div className="submit-section">
                <button
                label={label}
                disabled={disabled || disable}
                  className="btn btn-primary submit-btn"
                  type="submit"
                  {...(isUserDataValid ? { "data-bs-dismiss": "modal" } : {})}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
  if (typeof document !== "undefined" && document.body) {
    return ReactDOM.createPortal(modal, document.body);
  }
  return modal;
};

export default Modal;
